import { useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { ApplicationState } from '@/state/root.models'

import { PopoverConfirmType } from '@/state/ui/global/models'
import { GlobalUIActions } from '@/state/ui/global/slices/index.slices'

export type PopoverOptionalProps = {
  caption?: string
  cancelBtnText?: string
  message?: string
  object?: any
  handler?: any
  btnText?: string
}

const usePopoverConfirm = () => {
  const dispatch = useDispatch()

  const { popoverConfirm } = useSelector(
    ({ globalUi }: ApplicationState) => globalUi,
  )

  const handleOpenPopoverConfirm = useCallback(
    (props: Omit<PopoverConfirmType, 'open'>) => {
      dispatch(
        GlobalUIActions.setPopoverConfirmAction({
          open: true,
          ...props,
        }),
      )
    },
    [dispatch],
  )

  const handleClosePopoverConfirm = useCallback(() => {
    dispatch(
      GlobalUIActions.setPopoverConfirmAction({
        open: false,
        action: '',
        type: '',
        anchorPosition: {
          top: 0,
          left: 0,
        },
        handler: () => null,
      }),
    )
  }, [dispatch])
  return {
    popoverConfirm,
    handleClosePopoverConfirm,
    handleOpenPopoverConfirm,
  }
}

export default usePopoverConfirm
